import { container } from 'tsyringe';
import { constructor } from 'tsyringe/dist/typings/types';

export default function useResolver<T>(type: constructor<T>): T {
  return container.resolve<T>(type);
}
